/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  CHANGEMAILINGADDRESS_UPLOADDOCUMENT_TEXT_BORROWERS: 'settings.loans.changeMailingAddress.uploadDocument.text.borrowers',
  CONFIRMATION_ROW_LOANNUMBER: 'settings.loans.confirmation.row.loanNumber',
  HOME_CARDLINK_ADDLOAN_LABEL: 'settings.loans.home.row.addLoan.button.label',
  HOME_CARDLINK_REGISTEREDLOANS_DETAILS: 'settings.loans.home.row.registeredLoans.details',
  HOME_CARDLINK_REGISTEREDLOANS_LABEL: 'settings.loans.home.row.registeredLoans.button.label',
  HOME_CONTAINER_ALLLOANS_BUTTON_LABEL: 'settings.loans.home.container.allLoans.button.label',
  HOME_CONTAINER_BUTTON_LABEL: 'settings.loans.home.container.button.label',
  HOME_CONTAINER_HEADING: 'settings.loans.home.container.heading',
  HOME_CONTAINER_PARAGRAPH: 'settings.loans.home.container.paragraph',
  HOME_LOANCARD_HEADING: 'settings.loans.home.loanCard.heading',
  HOME_LOANCARD_PRIMARYLOAN_BUTTON_ARIALABEL: 'settings.loans.home.loanCard.primaryLoan.button.ariaLabel',
  HOME_LOANCARD_PRIMARYLOAN_BUTTON_LABEL: 'settings.loans.home.loanCard.primaryLoan.button.label',
  HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_LABEL: 'settings.loans.home.loanCard.primaryLoan.tooltip.label',
  HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_TEXT: 'settings.loans.home.loanCard.primaryLoan.tooltip.text',
  HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_TITLE: 'settings.loans.home.loanCard.primaryLoan.tooltip.title',
  LOANSCONTENT_ADDLOAN_ADDLOANVIEW_HEADER: 'settings.loans.loansContent.addLoan.addLoanView.header',
  LOANSCONTENT_ADDLOAN_ADDLOANVIEW_LOANNUMBER_LABEL: 'settings.loans.loansContent.addLoan.addLoanView.loanNumber.label',
  LOANSCONTENT_ADDLOAN_CONFIRMATIONVIEW_SUBHEADER: 'settings.loans.loansContent.addLoan.confirmationView.subHeader',
  LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_DESKTOP_TEXT: 'settings.loans.loansContent.cancelMailingAddress.stepOneView.desktop.text',
  LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_MOBILE_TEXT: 'settings.loans.loansContent.cancelMailingAddress.stepOneView.mobile.text',
  MESSAGE_ADDLOAN_ERROR: 'settings.loans.message.addLoan.error',
  MESSAGE_CHANGE_PRIMARYLOAN_ERROR: 'settings.loans.message.changePrimaryLoan.error',
  MESSAGE_CHANGE_PRIMARYLOAN_SUCCESS: 'settings.loans.message.changePrimaryLoan.success',
  REASONCODE_3004_ALREADYADDED: 'settings.loans.reasonCode.3004.alreadyAdded',
  REASONCODE_3004_INVALIDREQUEST: 'settings.loans.reasonCode.3004.invalidRequest',
  REASONCODE_3004_MAINONLINEPLATFORM: 'settings.loans.reasonCode.3004.mainOnlinePlatform',
  REASONCODE_3004_MISSINGFIELDS: 'settings.loans.reasonCode.3004.missingFields',
  REASONCODE_3004_SUCCESSFULLYADDED: 'settings.loans.reasonCode.3004.successfullyAdded',
  REASONCODE_26000_ADDRESSCANNOTBECHANGED: 'settings.loans.reasonCode.26000.addressCannotBeChanged',
  REASONCODE_26002_BORROWERNAME: 'settings.loans.reasonCode.26002.borrowerName',
  REGISTEREDLOANS_ADDLOAN_BUTTON_LABEL: 'settings.loans.registeredLoans.addLoan.button.label',
  REGISTEREDLOANS_HEADER_TITLE: 'settings.loans.registeredLoans.header.title',
};

const enMessages = {
  [IDS.CHANGEMAILINGADDRESS_UPLOADDOCUMENT_TEXT_BORROWERS]: 'borrowers',
  [IDS.CONFIRMATION_ROW_LOANNUMBER]: 'Loan Number',
  [IDS.HOME_CARDLINK_ADDLOAN_LABEL]: 'Add New Loan',
  [IDS.HOME_CARDLINK_REGISTEREDLOANS_DETAILS]: '{registeredLoansCount, plural, one {# loan} other {# loans}}',
  [IDS.HOME_CARDLINK_REGISTEREDLOANS_LABEL]: 'Registered Loans',
  [IDS.HOME_CONTAINER_ALLLOANS_BUTTON_LABEL]: 'See All Loans ({loanCount})',
  [IDS.HOME_CONTAINER_BUTTON_LABEL]: 'Add New Loan',
  [IDS.HOME_CONTAINER_HEADING]: 'Loans and Mailing Addresses',
  [IDS.HOME_CONTAINER_PARAGRAPH]: 'These are the property and mailing addresses associated with your loans. You can update the mailing address for eligible loans.',
  [IDS.HOME_LOANCARD_HEADING]: 'Loan ({loan})',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_BUTTON_ARIALABEL]: 'primary-loan-toggle',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_BUTTON_LABEL]: 'Primary Loan',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_LABEL]: 'primary loan tooltip',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_TEXT]: 'This is the default loan when you log in. You can change your primary loan at anytime.',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_TITLE]: 'Set as primary loan',
  [IDS.LOANSCONTENT_ADDLOAN_ADDLOANVIEW_HEADER]: 'Add New Loan',
  [IDS.LOANSCONTENT_ADDLOAN_ADDLOANVIEW_LOANNUMBER_LABEL]: 'Loan Number',
  [IDS.LOANSCONTENT_ADDLOAN_CONFIRMATIONVIEW_SUBHEADER]: 'Success!\nYour loan has been added',
  [IDS.LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_DESKTOP_TEXT]: 'A new mailing address was submitted for <b>Loan ...{{selectedLoan}} ({{streetAddress}})</b>. The change will be reflected within 2 business days.',
  [IDS.LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_MOBILE_TEXT]: 'A new mailing address was submitted for <b>Loan ...{{selectedLoan}} ({{streetAddress}})</b>.\n\nThe change will be reflected within 2 business days.',
  [IDS.MESSAGE_ADDLOAN_ERROR]: 'There was an issue adding the loan.',
  [IDS.MESSAGE_CHANGE_PRIMARYLOAN_ERROR]: 'Sorry! Unable to update primary loan',
  [IDS.MESSAGE_CHANGE_PRIMARYLOAN_SUCCESS]: 'Primary loan updated',
  [IDS.REASONCODE_3004_ALREADYADDED]: 'Loan has already been added',
  [IDS.REASONCODE_3004_INVALIDREQUEST]: 'Invalid loan request',
  [IDS.REASONCODE_3004_MAINONLINEPLATFORM]: "Add a new loan by accessing your mortgage provider's main online platform.",
  [IDS.REASONCODE_3004_MISSINGFIELDS]: 'One or more form fields is required. Please recheck the Add Loan form.',
  [IDS.REASONCODE_3004_SUCCESSFULLYADDED]: 'Your loan was successfully added. It may take some time before your loan is available to view.',
  [IDS.REASONCODE_26000_ADDRESSCANNOTBECHANGED]: 'Address cannot be changed online. Loan has additional borrower',
  [IDS.REASONCODE_26002_BORROWERNAME]: 'Borrower name cannot be changed',
  [IDS.REGISTEREDLOANS_ADDLOAN_BUTTON_LABEL]: 'Add New Loan',
  [IDS.REGISTEREDLOANS_HEADER_TITLE]: 'Registered Loans',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.CHANGEMAILINGADDRESS_UPLOADDOCUMENT_TEXT_BORROWERS]: 'debtors',
  [IDS.CONFIRMATION_ROW_LOANNUMBER]: 'Account Number',
  [IDS.HOME_CARDLINK_ADDLOAN_LABEL]: 'Add New Account',
  [IDS.HOME_CARDLINK_REGISTEREDLOANS_DETAILS]: '{registeredLoansCount, plural, one {# account} other {# accounts}}',
  [IDS.HOME_CARDLINK_REGISTEREDLOANS_LABEL]: 'Registered Accounts',
  [IDS.HOME_CONTAINER_ALLLOANS_BUTTON_LABEL]: 'See All Accounts ({loanCount})',
  [IDS.HOME_CONTAINER_BUTTON_LABEL]: 'Add New Account',
  [IDS.HOME_CONTAINER_HEADING]: 'Accounts and Mailing Addresses',
  [IDS.HOME_CONTAINER_PARAGRAPH]: 'These are the property and mailing addresses associated with your accounts. You can update the mailing address for eligible accounts.',
  [IDS.HOME_LOANCARD_HEADING]: 'Account ({loan})',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_BUTTON_ARIALABEL]: 'primary-account-toggle',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_BUTTON_LABEL]: 'Primary Account',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_LABEL]: 'primary account tooltip',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_TEXT]: 'This is the default account when you log in. You can change your primary account at anytime.',
  [IDS.HOME_LOANCARD_PRIMARYLOAN_TOOLTIP_TITLE]: 'Set as primary account',
  [IDS.LOANSCONTENT_ADDLOAN_ADDLOANVIEW_HEADER]: 'Add New Account',
  [IDS.LOANSCONTENT_ADDLOAN_ADDLOANVIEW_LOANNUMBER_LABEL]: 'Account Number',
  [IDS.LOANSCONTENT_ADDLOAN_CONFIRMATIONVIEW_SUBHEADER]: 'Success!\nYour account has been added',
  [IDS.LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_DESKTOP_TEXT]: 'A new mailing address was submitted for <b>Account ...{{selectedLoan}} ({{streetAddress}})</b>. The change will be reflected within 2 business days.',
  [IDS.LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_MOBILE_TEXT]: 'A new mailing address was submitted for <b>Account ...{{selectedLoan}} ({{streetAddress}})</b>.\n\nThe change will be reflected within 2 business days.',
  [IDS.MESSAGE_ADDLOAN_ERROR]: 'There was an issue adding the account.',
  [IDS.MESSAGE_CHANGE_PRIMARYLOAN_ERROR]: 'Sorry! Unable to update primary account',
  [IDS.MESSAGE_CHANGE_PRIMARYLOAN_SUCCESS]: 'Primary account updated',
  [IDS.REASONCODE_3004_ALREADYADDED]: 'Account has already been added',
  [IDS.REASONCODE_3004_INVALIDREQUEST]: 'Invalid account request',
  [IDS.REASONCODE_3004_MAINONLINEPLATFORM]: "Add a new account by accessing your mortgage provider's main online platform.",
  [IDS.REASONCODE_3004_MISSINGFIELDS]: 'One or more form fields is required. Please recheck the Add Account form.',
  [IDS.REASONCODE_3004_SUCCESSFULLYADDED]: 'Your account was successfully added. It may take some time before your account is available to view.',
  [IDS.REASONCODE_26000_ADDRESSCANNOTBECHANGED]: 'Address cannot be changed online. Account has additional debtor',
  [IDS.REASONCODE_26002_BORROWERNAME]: 'Debtor name cannot be changed',
  [IDS.REGISTEREDLOANS_ADDLOAN_BUTTON_LABEL]: 'Add New Account',
  [IDS.REGISTEREDLOANS_HEADER_TITLE]: 'Registered Accounts',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
